import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import SupportCTA from './components/SupportCTA';
import Footer from './components/Footer';
import GuideSection from './components/GuideSection';

export default function App() {
  // Final JavaScript fallback: Forces the DOM elements to the exact color after React mounts
  useEffect(() => {
    document.documentElement.style.setProperty('background-color', '#0D1B3E', 'important');
    document.body.style.setProperty('background-color', '#0D1B3E', 'important');
    document.body.style.setProperty('color', '#ffffff', 'important');
  }, []);

  return (
    <div className="flex-1 flex flex-col w-full selection:bg-purple selection:text-white font-space relative z-10">
      <Navbar />
      {/* Main content wrapper */}
      <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 md:pt-32 pb-16 md:pb-24 relative z-10">
        <Hero />
        <GuideSection />
      </main>
      <SupportCTA />
      <Footer />
    </div>
  );
}